/**
 * 楼号 -> 建筑名称
 *
 * scenetree.json 里 type=element 的 name 字段只是楼号（"1" ~ "23"，以及 part1 里的 "10-1"），
 * 这里把楼号映射成实际的市场名称，标牌上显示的就是这张表的右值。
 *
 * 匹配规则：**必须精确命中**。楼号在表里找不到对应名称时，不生成标牌：
 *   · 当前 tileset 里没有 3 / 4 / 9 / 18 号楼的几何（没有对应分片），
 *     「3.苏杭首站」「9.佳宝原创设计师女装」「18.爱尚潮品汇」暂时不会出现，
 *     以后补上对应分片的数据就会自动显示，无需改代码；
 *   · 4 号楼（旺田）的几何并进了 12 号楼（中洲女装城）的分片，scenetree 里
 *     查不到 element "4"，由 loadCityTiles 的 EXTRA_LABELS 按「宿主楼 + 偏移」补一块标牌；
 *   · part1 里还有个 "10-1"（与 part2 的 "10" 相距约 760 米，是另一块几何体），
 *     不在这张表的 1~23 里，因此也不显示。若确认它其实就是小白楼，
 *     在这里加一行 `'10-1': '小白楼',` 即可。
 *
 * 维护方式：拿到新的楼号/名称，直接在这里加一行。
 */
export const BUILDING_NAMES = {
  1: '尚城女装中心',
  2: '新九天女装大厦',
  3: '苏杭首站',
  4: '旺田·精品女装市场',
  5: '维众精品汇',
  6: '保太和饰品区',
  7: '新意法女装大厦',
  8: '杭州四季青面料市场',
  9: '佳宝原创设计师女装',
  10: '小白楼',
  11: '意法清江服装城',
  12: '中洲女装城',
  13: '四季青服装市场',
  14: '中纺中心服装城',
  15: '杭州意法服饰城',
  16: '新中洲女装城',
  17: '杭派精品服装市场',
  18: '爱尚潮品汇',
  19: 'T9青年引力场',
  20: '昆龙童装城',
  21: '四季青精品童装市场',
  22: '常青休闲女装市场',
  23: '杭泵精品男装市场',
}

/** 按 scenetree 的楼号取显示名称，没有对应项时返回 null（调用方据此跳过该建筑） */
export function buildingDisplayName(code) {
  if (code === undefined || code === null) return null
  const v = BUILDING_NAMES[String(code)]
  return v || null
}
